import { render, staticRenderFns } from "./SectionCompany.vue?vue&type=template&id=70ee27b3&scoped=true&"
import script from "./SectionCompany.vue?vue&type=script&lang=ts&"
export * from "./SectionCompany.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCompany.vue?vue&type=style&index=0&id=70ee27b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee27b3",
  null
  
)

export default component.exports